<template>
  <section class="about-page">

    <!-- 鼠标光晕 -->
    <div class="cursor-glow" ref="cursorGlow"></div>

    <!-- =================== Hero（居中布局） =================== -->
    <div class="hero" ref="hero">
      <div class="orb orb--1" ref="orb1"></div>
      <div class="orb orb--2" ref="orb2"></div>
      <div class="orb orb--3" ref="orb3"></div>
      <div class="hero__overlay"></div>

      <div class="hero__body">
        <div class="hero__badge" ref="heroBadge"><span class="hero__dot"></span>关于糖德</div>
        <div class="clip-wrap">
          <h1 class="hero__title clip-inner">关于糖德</h1>
        </div>
        <div class="clip-wrap" style="margin-top:.5rem;">
          <p class="hero__sub clip-inner">About us — 厦门鸿宁兴科技有限公司</p>
        </div>

        <!-- 锚点导航 -->
        <div class="hero__nav" ref="heroNav">
          <a
            v-for="item in aboutData"
            :key="item.id"
            class="hero__nav-link magnetic"
            @click="anchor(item.id)"
          >{{ item.name }}</a>
        </div>

        <!-- 统计数据 -->
        <div class="hero__stats" ref="heroStats">
          <div class="hero__stat" v-for="s in heroStatData" :key="s.label">
            <div class="hero__stat-row">
              <span class="hero__stat-num" :data-target="s.num">0</span>
              <span class="hero__stat-unit">{{ s.unit }}</span>
            </div>
            <p class="hero__stat-label">{{ s.label }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- =================== 企业介绍 =================== -->
    <div class="sec sec--white" id="content1" ref="introSection">
      <div class="sec__inner intro-layout">

        <!-- 文字侧 -->
        <div class="intro-text" ref="introText">
          <span class="sec__label reveal-chip">ENTERPRISE INTRODUCTION</span>
          <div class="title-mask" ref="introTitleMask">
            <h2 class="title-mask__inner" style="text-align:left;">企业介绍</h2>
          </div>
          <h3 class="intro-slogan" ref="introSlogan">以简驭繁、还原生活本真</h3>
          <div class="intro-bar" ref="introBar"></div>
          <p class="intro-desc" ref="introDesc">
            厦门鸿宁兴科技有限公司属于一体化数字采购管理服务商，通过提供SaaS采购数字化产品，
            致力于数字化采购变革，为企业提供企业采购数字化解决方案，推动企业采购更加智能、
            高效、透明，赋能企业经营发展降本提效。
          </p>

          <!-- MVV 卡片 -->
          <div class="mvv-list">
            <div
              class="mvv-card"
              v-for="(mvv, i) in mvvData"
              :key="mvv.label"
              ref="mvvCards"
            >
              <span class="mvv-card__idx">{{ String(i + 1).padStart(2, '0') }}</span>
              <div class="mvv-card__body">
                <h4 class="mvv-card__label">{{ mvv.label }}</h4>
                <p class="mvv-card__text">{{ mvv.text }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- 图片侧 -->
        <div class="intro-img" ref="introImg">
          <div class="intro-img__glow"></div>
          <img src="../assets/tutop.png" alt="企业介绍" />
        </div>
      </div>
    </div>

    <!-- =================== 业务与服务 =================== -->
    <div class="sec sec--dark" id="content2" ref="bizSection">
      <!-- 背景网格 -->
      <div class="biz-grid-bg"></div>
      <div class="sec__inner" style="position:relative;z-index:1;">
        <div class="sec__head" ref="bizHead">
          <span class="sec__label sec__label--light reveal-chip">BUSINESS &amp; SERVICE</span>
          <div class="title-mask">
            <h2 class="title-mask__inner title-mask__inner--light">业务与服务</h2>
          </div>
          <p class="sec__desc sec__desc--light" ref="bizDesc">专业、高效、可靠的一站式数字化服务体系</p>
        </div>

        <div class="biz-grid">
          <div
            class="biz-card"
            v-for="(item, i) in businessData"
            :key="item.title"
            ref="bizCards"
          >
            <!-- 背景序号 -->
            <span class="biz-card__bg-num">{{ String(i + 1).padStart(2, '0') }}</span>
            <div class="biz-card__icon">
              <img :src="item.img" :alt="item.title" />
            </div>
            <h3 class="biz-card__title">{{ item.title }}</h3>
            <p class="biz-card__text">{{ item.text }}</p>
            <!-- 底部扫光线 -->
            <div class="biz-card__line"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- =================== 合作伙伴 — 跑马灯 =================== -->
    <div class="partner-section" id="content3" ref="partnerSection">
      <div class="sec__inner" style="padding:5rem 7.5rem 2.5rem;">
        <div class="sec__head" ref="partnerHead">
          <span class="sec__label reveal-chip">COOPERATIVE PARTNER</span>
          <div class="title-mask">
            <h2 class="title-mask__inner">我们的合作伙伴</h2>
          </div>
          <p class="sec__desc" ref="partnerDesc">与每一种力量，共筑智慧、便捷、美好生活</p>
        </div>
      </div>
      <!-- 全宽跑马灯 -->
      <div class="marquee-outer">
        <div class="marquee-track" ref="marqueeTrack">
          <div
            v-for="(item, i) in marqueeLogos"
            :key="i"
            class="marquee-logo"
          ><img :src="item.img" /></div>
        </div>
      </div>
      <div style="height:4rem;"></div>
    </div>

  </section>
</template>

<script>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  data() {
    return {
      heroStatData: [
        { num: 10,  unit: '+',  label: '年行业经验' },
        { num: 500, unit: '+',  label: '合作商户'   },
        { num: 6,   unit: '×24h', label: '售后支持' },
      ],
      aboutData: [
        { name: '企业介绍',  id: 'content1' },
        { name: '业务与服务', id: 'content2' },
        { name: '合作伙伴',  id: 'content3' },
      ],
      mvvData: [
        { label: '使命', text: '坚持一丝不苟的品质控制、力求每个细节的完美呈现。' },
        { label: '愿景', text: '成为一家全球化科技公司、为产品后的每个企业负责。' },
        { label: '核心价值观', text: '长期价值、用户体验、数据、纯粹、极致、突破边界。' },
      ],
      cooperationData: [
        { img: require('../assets/co1.png') },  { img: require('../assets/co2.png') },
        { img: require('../assets/co3.png') },  { img: require('../assets/co4.png') },
        { img: require('../assets/co5.png') },  { img: require('../assets/co6.png') },
        { img: require('../assets/co7.png') },  { img: require('../assets/co8.png') },
        { img: require('../assets/co9.png') },  { img: require('../assets/co10.png') },
        { img: require('../assets/co11.png') }, { img: require('../assets/co12.png') },
      ],
      businessData: [
        { img: require('../assets/tu1.png'), title: 'SaaS 开放平台',  text: '丰富的 API 和 SDK，支持定制企业专属的应用' },
        { img: require('../assets/tu2.png'), title: '主营业务',        text: '与餐饮企业战略合作，打造 OEM 数据一体化支付平台。' },
        { img: require('../assets/tu3.png'), title: '定制化服务',      text: '支持大型销售团队定制开发服务' },
        { img: require('../assets/tu4.png'), title: '24 小时响应',     text: '24 小时快速响应客户需求，第一时间解决' },
        { img: require('../assets/tu5.png'), title: '现场培训',        text: '提供现场系统使用培训服务，帮助员工快速上手' },
        { img: require('../assets/tu6.png'), title: 'SLA 承诺',        text: '为服务的有效性、可靠性、专业性提供保障' },
      ],
    }
  },

  computed: {
    /** 三倍复制，无限跑马灯 */
    marqueeLogos() {
      return [...this.cooperationData, ...this.cooperationData, ...this.cooperationData]
    },
  },

  mounted() {
    this.$nextTick(() => {
      this._initCursorGlow()
      this._initHeroAnimations()
      this._initIntroSection()
      this._initBizSection()
      this._initPartners()
      this._initMagnetic()
    })
  },

  beforeDestroy() {
    ScrollTrigger.getAll().forEach(t => t.kill())
    document.removeEventListener('mousemove', this._cursorHandler)
  },

  methods: {
    /* ─── 鼠标光晕 ─── */
    _initCursorGlow() {
      const glow = this.$refs.cursorGlow
      if (!glow) return
      this._cursorHandler = (e) => {
        gsap.to(glow, { x: e.clientX, y: e.clientY, duration: 0.6, ease: 'power2.out' })
      }
      document.addEventListener('mousemove', this._cursorHandler)
    },

    /* ─── Hero 入场 ─── */
    _initHeroAnimations() {
      /* 光球浮动 */
      if (this.$refs.orb1) gsap.to(this.$refs.orb1, { y: -55, x: 30, duration: 5, repeat: -1, yoyo: true, ease: 'sine.inOut' })
      if (this.$refs.orb2) gsap.to(this.$refs.orb2, { y: 40,  x: -25, duration: 6.5, repeat: -1, yoyo: true, ease: 'sine.inOut', delay: 1 })
      if (this.$refs.orb3) gsap.to(this.$refs.orb3, { y: -30, x: 20, duration: 4, repeat: -1, yoyo: true, ease: 'sine.inOut', delay: 0.5 })

      const tl = gsap.timeline({ delay: 0.2 })
      tl.from(this.$refs.heroBadge, { scale: 0, opacity: 0, duration: 0.5, ease: 'back.out(2)' })
        .from('.clip-inner', { yPercent: 105, opacity: 0, duration: 0.9, ease: 'expo.out', stagger: 0.18 }, '-=0.2')
        .from(Array.from(this.$refs.heroNav?.children || []), { y: 20, opacity: 0, duration: 0.5, ease: 'power3.out', stagger: 0.08 }, '-=0.4')
        .from(Array.from(this.$refs.heroStats?.children || []), { y: 20, opacity: 0, duration: 0.45, ease: 'power3.out', stagger: 0.08 }, '-=0.3')

      /* 数字计数 */
      this.$el.querySelectorAll('.hero__stat-num').forEach((el) => {
        gsap.fromTo(el, { innerHTML: 0 }, {
          innerHTML: parseInt(el.dataset.target, 10),
          duration: 2, ease: 'power2.out',
          snap: { innerHTML: 1 }, delay: 1.3,
        })
      })

      /* 视差 */
      gsap.to(this.$refs.orb1, { y: -120, ease: 'none',
        scrollTrigger: { trigger: this.$refs.hero, scrub: 1, start: 'top top', end: 'bottom top' } })
    },

    /* ─── 企业介绍 ─── */
    _initIntroSection() {
      const section = this.$refs.introSection
      if (!section) return

      /* label chip */
      const chip = section.querySelector('.reveal-chip')
      if (chip) {
        gsap.fromTo(chip, { x: -20, opacity: 0 },
          { x: 0, opacity: 1, duration: 0.6, ease: 'power3.out',
            scrollTrigger: { trigger: chip, start: 'top 88%', once: true }, clearProps: 'transform,opacity' })
      }
      /* 标题遮幕揭示 */
      const titleInner = section.querySelector('.title-mask__inner')
      if (titleInner) {
        gsap.fromTo(titleInner, { yPercent: 110 },
          { yPercent: 0, duration: 1, ease: 'expo.out',
            scrollTrigger: { trigger: titleInner, start: 'top 88%', once: true }, clearProps: 'transform' })
      }

      /* slogan + bar + desc：scrub 逐一揭示 */
      const textEls = [this.$refs.introSlogan, this.$refs.introBar, this.$refs.introDesc].filter(Boolean)
      textEls.forEach((el, i) => {
        gsap.fromTo(el, { y: 25, opacity: 0 },
          { y: 0, opacity: 1, ease: 'none',
            scrollTrigger: { trigger: el, start: 'top 90%', end: 'top 70%', scrub: 0.5 },
            clearProps: 'transform,opacity' })
      })

      /* MVV 卡片：scrub timeline 从左滑入 */
      const mvvCards = Array.from(this.$el.querySelectorAll('.mvv-card'))
      if (mvvCards.length) {
        const tl = gsap.timeline({
          scrollTrigger: { trigger: mvvCards[0], start: 'top 85%', end: 'top 40%', scrub: 0.6 },
        })
        mvvCards.forEach((card, i) => {
          tl.fromTo(card, { x: -50, opacity: 0 }, { x: 0, opacity: 1, duration: 0.5 }, i * 0.12)
        })
      }

      /* 图片：scrub 3D 从右划入 + 持续视差 */
      const img = this.$refs.introImg
      if (img) {
        gsap.fromTo(img,
          { x: 80, opacity: 0, rotateY: 18, transformPerspective: 900 },
          { x: 0, opacity: 1, rotateY: 0, ease: 'none',
            scrollTrigger: { trigger: section, start: 'top 75%', end: 'center 45%', scrub: 0.8 },
            clearProps: 'transform,opacity' })
        gsap.to(img, { y: -50, ease: 'none',
          scrollTrigger: { trigger: section, scrub: 1.5, start: 'top bottom', end: 'bottom top' } })
      }
    },

    /* ─── 业务与服务 ─── */
    _initBizSection() {
      const section = this.$refs.bizSection
      if (!section) return

      /* 标题揭示 */
      const chip = section.querySelector('.reveal-chip')
      if (chip) {
        gsap.fromTo(chip, { x: -20, opacity: 0 },
          { x: 0, opacity: 1, duration: 0.6, ease: 'power3.out',
            scrollTrigger: { trigger: chip, start: 'top 88%', once: true }, clearProps: 'transform,opacity' })
      }
      const titleInner = section.querySelector('.title-mask__inner')
      if (titleInner) {
        gsap.fromTo(titleInner, { yPercent: 110 },
          { yPercent: 0, duration: 1, ease: 'expo.out',
            scrollTrigger: { trigger: titleInner, start: 'top 88%', once: true }, clearProps: 'transform' })
      }

      /* 业务卡片：scrub timeline */
      const cards = Array.from(this.$el.querySelectorAll('.biz-card'))
      if (cards.length) {
        const tl = gsap.timeline({
          scrollTrigger: { trigger: cards[0], start: 'top 85%', end: 'top 30%', scrub: 0.7 },
        })
        cards.forEach((card, i) => {
          tl.fromTo(card,
            { y: 70, opacity: 0, scale: 0.88 },
            { y: 0, opacity: 1, scale: 1, duration: 0.5 },
            i * 0.05)
        })

        /* 3D 倾斜 hover */
        cards.forEach((card) => {
          card.addEventListener('mousemove', (e) => {
            const r = card.getBoundingClientRect()
            gsap.to(card, {
              rotateY: ((e.clientX - r.left) / r.width  - 0.5) * 16,
              rotateX: -((e.clientY - r.top)  / r.height - 0.5) * 16,
              transformPerspective: 900, duration: 0.3, ease: 'power2.out',
            })
          })
          card.addEventListener('mouseleave', () => {
            gsap.to(card, { rotateY: 0, rotateX: 0, duration: 0.7, ease: 'elastic.out(1, 0.6)' })
          })
        })
      }
    },

    /* ─── 合作伙伴跑马灯 ─── */
    _initPartners() {
      const track = this.$refs.marqueeTrack
      if (!track) return

      this._marqueeTween = gsap.to(track, {
        x: '-33.333%', duration: 28, ease: 'none', repeat: -1,
      })
      track.addEventListener('mouseenter', () => this._marqueeTween.pause())
      track.addEventListener('mouseleave', () => this._marqueeTween.play())

      /* 标题揭示 */
      const chip = this.$refs.partnerSection?.querySelector('.reveal-chip')
      const titleInner = this.$refs.partnerSection?.querySelector('.title-mask__inner')
      if (chip) {
        gsap.fromTo(chip, { x: -20, opacity: 0 },
          { x: 0, opacity: 1, duration: 0.6, ease: 'power3.out',
            scrollTrigger: { trigger: chip, start: 'top 88%', once: true }, clearProps: 'transform,opacity' })
      }
      if (titleInner) {
        gsap.fromTo(titleInner, { yPercent: 110 },
          { yPercent: 0, duration: 1, ease: 'expo.out',
            scrollTrigger: { trigger: titleInner, start: 'top 88%', once: true }, clearProps: 'transform' })
      }
    },

    /* ─── 磁性按钮 ─── */
    _initMagnetic() {
      this.$el.querySelectorAll('.magnetic').forEach((btn) => {
        btn.addEventListener('mousemove', (e) => {
          const r = btn.getBoundingClientRect()
          gsap.to(btn, {
            x: (e.clientX - r.left - r.width  / 2) * 0.35,
            y: (e.clientY - r.top  - r.height / 2) * 0.35,
            duration: 0.3, ease: 'power2.out',
          })
        })
        btn.addEventListener('mouseleave', () => {
          gsap.to(btn, { x: 0, y: 0, duration: 0.6, ease: 'elastic.out(1, 0.5)' })
        })
      })
    },

    /** 锚点跳转 */
    anchor(id) {
      const el = document.getElementById(id)
      if (el) document.documentElement.scrollTop = el.offsetTop - 60
    },
  },
}
</script>

<style lang="scss" scoped>
$blue:   #0E6EB8;
$blue-l: #38A0F5;
$dark:   #0D1B2E;
$tint:   #F0F7FF;
$muted:  #6B7280;
$r-xl:   1.25rem;
$tr:     all .3s cubic-bezier(.4,0,.2,1);

/* ─── 光晕 ─── */
.cursor-glow {
  position: fixed; width: 28rem; height: 28rem; border-radius: 50%;
  background: radial-gradient(circle, rgba(14,110,184,.1), transparent 70%);
  pointer-events: none; transform: translate(-50%,-50%); z-index: 9990;
  mix-blend-mode: screen; will-change: transform;
}

/* ─── Hero（居中） ─── */
.hero {
  height: 46rem;
  background: url('../assets/tubg.png') no-repeat center center / cover;
  position: relative; display: flex; align-items: center; justify-content: center;
  overflow: hidden;

  .orb {
    position: absolute; border-radius: 50%; filter: blur(90px);
    pointer-events: none; z-index: 1; will-change: transform;
  }
  .orb--1 { width: 40rem; height: 40rem; background: rgba(14,110,184,.28); top: -12rem; right: -6rem; }
  .orb--2 { width: 26rem; height: 26rem; background: rgba(56,160,245,.2); bottom: 3rem; left: 5%; }
  .orb--3 { width: 18rem; height: 18rem; background: rgba(30,200,255,.15); top: 35%; left: 45%; }

  &__overlay {
    position: absolute; inset: 0; z-index: 1;
    background: linear-gradient(180deg, rgba(8,25,55,.75) 0%, rgba(14,110,184,.35) 55%, rgba(8,25,55,.65) 100%);
  }
  &__body {
    position: relative; z-index: 3;
    text-align: center; max-width: 60rem;
    display: flex; flex-direction: column; align-items: center;
    padding: 0 2rem;
  }
  &__badge {
    display: inline-flex; align-items: center; gap: .5rem;
    background: rgba(255,255,255,.12); backdrop-filter: blur(12px);
    border: 1px solid rgba(255,255,255,.25); color: #fff;
    font-size: .78rem; font-weight: 600; letter-spacing: .08em;
    padding: .38rem .95rem; border-radius: 5rem; margin-bottom: 1.2rem;
  }
  &__dot { width: .45rem; height: .45rem; border-radius: 50%; background: $blue-l; animation: pulse 2s infinite; }
  &__title {
    font-size: 3.2rem; font-weight: 900; color: #fff;
    line-height: 1.2; margin: 0 0 .5rem; text-shadow: 0 2px 24px rgba(0,0,0,.4);
  }
  &__sub  { font-size: .82rem; color: rgba(255,255,255,.65); letter-spacing: .06em; margin: 0; }

  /* 锚点导航 */
  &__nav {
    display: flex; gap: .75rem; flex-wrap: wrap; justify-content: center;
    margin: 2rem 0 2.5rem;
  }
  &__nav-link {
    font-size: .92rem; font-weight: 600; color: rgba(255,255,255,.85);
    padding: .5rem 1.5rem;
    border: 1px solid rgba(255,255,255,.3);
    border-radius: 3rem; cursor: pointer;
    backdrop-filter: blur(8px);
    background: rgba(255,255,255,.1);
    transition: $tr; will-change: transform;

    &:hover { background: rgba(255,255,255,.22); border-color: rgba(255,255,255,.7); color: #fff; }
  }

  /* 统计 */
  &__stats {
    display: flex; gap: 3rem; align-items: center;
    padding-top: 1.5rem; border-top: 1px solid rgba(255,255,255,.15);
  }
  &__stat-row  { display: flex; align-items: baseline; gap: .2rem; margin-bottom: .25rem; justify-content: center; }
  &__stat-num  { font-size: 2rem; font-weight: 900; color: #fff; line-height: 1; }
  &__stat-unit { font-size: .9rem; font-weight: 700; color: $blue-l; }
  &__stat-label { font-size: .75rem; color: rgba(255,255,255,.55); letter-spacing: .06em; text-align: center; }
}

.clip-wrap { overflow: hidden; line-height: 1; }
.clip-inner { display: block; }

/* ─── Section 通用 ─── */
.sec { padding: 5rem 7.5rem;
  &--white { background: #fff; }
  &--tint  { background: $tint; }
  &--dark  { background: $dark; }
}
.sec__inner { max-width: 1400px; margin: 0 auto; }
.sec__head  { text-align: center; margin-bottom: 3.5rem; }
.sec__label {
  display: inline-block; font-size: .72rem; font-weight: 700; letter-spacing: .2em;
  color: $blue; background: rgba(14,110,184,.09);
  padding: .3rem .9rem; border-radius: 5rem; margin-bottom: .8rem;
  &--light { color: $blue-l; background: rgba(56,160,245,.12); }
}
.title-mask { overflow: hidden; margin-bottom: .7rem; }
.title-mask__inner {
  display: block; font-size: 2.4rem; font-weight: 800; color: #1A2535; margin: 0;
  &--light { color: #fff; }
}
.sec__desc { font-size: .95rem; color: $muted; margin: 0;
  &--light { color: rgba(255,255,255,.6); }
}

/* ─── 企业介绍 ─── */
.intro-layout {
  display: flex; align-items: center; gap: 5.5rem;
}
.intro-text {
  flex: 1;
  .sec__label { display: inline-block; margin-bottom: .75rem; }
}
.intro-slogan {
  font-size: 1.55rem; font-weight: 800; color: #1A2535; margin: 1rem 0 .75rem;
}
.intro-bar {
  width: 3rem; height: 4px;
  background: linear-gradient(90deg, $blue, $blue-l);
  border-radius: 3px; margin-bottom: 1.5rem;
}
.intro-desc {
  font-size: .9rem; color: $muted; line-height: 1.9; margin: 0 0 2rem;
}

/* MVV 卡片 */
.mvv-list { display: flex; flex-direction: column; gap: .9rem; }
.mvv-card {
  display: flex; align-items: flex-start; gap: 1.25rem;
  background: $tint; border: 1px solid rgba(14,110,184,.12);
  border-left: 4px solid $blue;
  border-radius: .875rem; padding: 1.1rem 1.4rem;
  transition: $tr; will-change: transform;

  &:hover {
    border-color: rgba(14,110,184,.35); border-left-color: $blue-l;
    box-shadow: 0 8px 28px rgba(14,110,184,.12);
    transform: translateX(6px);
  }

  &__idx {
    flex-shrink: 0; font-size: 1.5rem; font-weight: 900;
    color: rgba(14,110,184,.22); line-height: 1;
    font-family: 'Arial', sans-serif; letter-spacing: -.04em;
  }
  &__body { flex: 1; }
  &__label { font-size: .95rem; font-weight: 800; color: $blue; margin: 0 0 .3rem; }
  &__text  { font-size: .85rem; color: $muted; line-height: 1.7; margin: 0; }
}

/* 图片侧 */
.intro-img {
  flex: 0 0 28rem; position: relative; will-change: transform;

  &__glow {
    position: absolute; inset: 5%;
    background: radial-gradient(circle, rgba(56,160,245,.2), transparent 70%);
    border-radius: 50%; animation: glowPulse 3.5s ease-in-out infinite;
    pointer-events: none;
  }

  img {
    width: 100%; position: relative; z-index: 1;
    filter: drop-shadow(0 20px 40px rgba(14,110,184,.2));
  }
}
@keyframes glowPulse {
  0%,100% { opacity: .5; transform: scale(1); }
  50%      { opacity: 1;  transform: scale(1.12); }
}

/* ─── 业务与服务（深色） ─── */
.biz-grid-bg {
  position: absolute; inset: 0;
  background-image:
    linear-gradient(rgba(56,160,245,.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(56,160,245,.04) 1px, transparent 1px);
  background-size: 60px 60px; pointer-events: none;
}
.sec--dark { position: relative; overflow: hidden; }

.biz-grid {
  display: grid; grid-template-columns: repeat(3, 1fr); gap: 1.5rem;
}
.biz-card {
  position: relative; overflow: hidden;
  background: rgba(255,255,255,.05);
  border: 1px solid rgba(255,255,255,.1);
  border-radius: $r-xl; padding: 2rem 1.75rem;
  transition: box-shadow .3s ease, border-color .3s ease; cursor: default;
  will-change: transform; transform-style: preserve-3d;

  &:hover {
    background: rgba(255,255,255,.1);
    border-color: rgba(56,160,245,.4);
    box-shadow: 0 14px 40px rgba(0,0,0,.3);
    .biz-card__line  { transform: scaleX(1); }
    .biz-card__icon  { background: linear-gradient(135deg, rgba(14,110,184,.4), rgba(56,160,245,.2)); }
    .biz-card__title { color: $blue-l; }
  }

  &__bg-num {
    position: absolute; top: .75rem; right: 1.25rem;
    font-size: 4.5rem; font-weight: 900; line-height: 1;
    color: rgba(255,255,255,.05); pointer-events: none;
    letter-spacing: -.05em; user-select: none;
  }
  &__icon {
    width: 3.75rem; height: 3.75rem;
    background: linear-gradient(135deg, rgba(14,110,184,.25), rgba(56,160,245,.12));
    border-radius: .875rem; border: 1px solid rgba(56,160,245,.2);
    display: flex; align-items: center; justify-content: center;
    margin-bottom: 1.25rem; transition: $tr;
    img { width: 2.1rem; height: 2.1rem; object-fit: contain; filter: brightness(0) invert(1) opacity(.85); }
  }
  &__title {
    font-size: 1.05rem; font-weight: 800; color: #fff;
    margin: 0 0 .6rem; transition: color .25s ease;
  }
  &__text  { font-size: .875rem; color: rgba(255,255,255,.58); line-height: 1.7; margin: 0; }
  &__line  {
    position: absolute; bottom: 0; left: 0; right: 0; height: 3px;
    background: linear-gradient(90deg, $blue, $blue-l);
    transform: scaleX(0); transform-origin: left;
    transition: transform .4s cubic-bezier(.4,0,.2,1);
    border-radius: 3px 3px 0 0;
  }
}

/* ─── 合作伙伴跑马灯 ─── */
.partner-section { background: $tint; }
.sec__inner { max-width: 1400px; margin: 0 auto; }

.marquee-outer {
  overflow: hidden; padding: 1rem 0;
  mask-image: linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent);
  -webkit-mask-image: linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent);
}
.marquee-track { display: inline-flex; will-change: transform; }
.marquee-logo {
  flex-shrink: 0; width: 11rem; height: 6rem; margin: 0 1rem;
  display: flex; align-items: center; justify-content: center;
  background: #fff; border: 1px solid rgba(14,110,184,.1);
  border-radius: 1rem; padding: 1rem 1.5rem;
  box-shadow: 0 2px 12px rgba(14,110,184,.06);
  transition: $tr; cursor: default;
  &:hover { transform: scale(1.06); box-shadow: 0 8px 28px rgba(14,110,184,.18); border-color: rgba(14,110,184,.3); }
  img { max-width: 100%; max-height: 100%; object-fit: contain; }
}

/* ─── Keyframes ─── */
@keyframes pulse {
  0%,100% { opacity: 1; transform: scale(1); }
  50%      { opacity: .5; transform: scale(1.4); }
}
</style>

<style>
@media screen and (max-width: 600px) {
  .cursor-glow { display: none; }
  .about-page .hero { margin-top: 70px; min-height: 32rem; height: auto !important; padding: 3rem 0; }
  .about-page .sec { padding: 3rem 1.5rem !important; }
  .intro-layout { flex-direction: column !important; }
  .intro-img { flex: none !important; width: 100% !important; }
  .biz-grid { grid-template-columns: 1fr !important; }
  .hero__stats { gap: 1.5rem !important; flex-wrap: wrap; }
  .hero__nav { gap: .5rem !important; }
}
</style>
